import type { ChannelKind, OpenUrlWithKind } from '@api/generated/models';
import { FlexibleBaseSpecification, FlexibleModelBase } from './flexible_base';

interface Icon {
	origin: string;
	type: 'svgUrl' | 'pngUrl' | 'local';
}

export interface FlexibleButtonIconSpecification extends FlexibleBaseSpecification {
	id: number;
	title: string;
	url: string;
	requiresAuthentication: boolean;
	openAnotherApp: boolean;
	hasBrandedNavbar: boolean;
	icon: Icon | null;
	subtitle: string;
	openUrlWith: OpenUrlWithKind;
	channel: ChannelKind | null;
}

export class FlexibleButtonIconModel extends FlexibleModelBase {
	public readonly title: string;
	public readonly url: string;
	public readonly requiresAuthentication: boolean;
	public readonly openAnotherApp: boolean;
	public readonly hasBrandedNavbar: boolean;
	public readonly icon: Icon | null;
	public readonly subtitle: string;
	public readonly openUrlWith: OpenUrlWithKind;
	public readonly channel: ChannelKind | null;

	constructor(spec: FlexibleButtonIconSpecification) {
		super(spec);

		this.title = spec.title;
		this.url = spec.url;
		this.requiresAuthentication = spec.requiresAuthentication;
		this.openAnotherApp = spec.openAnotherApp;
		this.hasBrandedNavbar = spec.hasBrandedNavbar;
		this.icon = spec.icon;
		this.subtitle = spec.subtitle;
		this.openUrlWith = spec.openUrlWith;
		this.channel = spec.channel;
	}
}
